/** The sentence the "Multiple positions" badge's tooltip and aria-label carry. */
export function multiplePositionsDescription(maxPositions: number | null = null, engineApi: number | null = null): string {
  // A cap of 1 is what hedging code without a max_positions literal is stored with (the
  // engine's default): "several ... up to 1" would contradict itself, so it is said as it is.
  const perSide =
    maxPositions === 1 ? 'one per side (a long and a short at once)' : maxPositions != null ? `up to ${maxPositions} per side` : 'several per side'
  const desktop = engineApi != null && engineApi >= 3 ? ' and AlgoBuilder desktop 0.4 or later' : ''
  return `Holds several positions at once (${perSide}). Live trading needs a hedging MetaTrader 5 account${desktop} — a netting account is refused.`
}
